import { eventConstants } from "../actions/types";

const initialState = { loading: false, data: [], error: "" };

const settingReducer = (state = initialState, action) => {
  switch (action.type) {
    case eventConstants.GET_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case eventConstants.GET_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.events,
        totalPages: action.totalPages,
        error: "",
      };
    case eventConstants.GET_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case eventConstants.CREATE_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case eventConstants.CREATE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [action.event, ...state.data],
        error: "",
      };
    case eventConstants.CREATE_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        data: [],
        error: action.error,
      };
    case eventConstants.DELETE_EVENT_REQUEST:
      return {
        ...state,
        error: "",
      };
    case eventConstants.DELETE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.events,
        error: "",
      };
    case eventConstants.DELETE_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return { ...state };
  }
};

export default settingReducer;
